import { RegistrationDtoInFormTypeEnum } from '../../generated';
import { RequestType } from '../../model/enums/RequestType';

export const fromRequestTypeToGenerated = (data: RequestType): RegistrationDtoInFormTypeEnum => {
  switch (data) {
    case RequestType.DoctorRegistration:
      return RegistrationDtoInFormTypeEnum.DoctorRegistration;
    case RequestType.PatientRegistration:
      return RegistrationDtoInFormTypeEnum.PatientRegistration;
    case RequestType.ReceiptOrder:
      return RegistrationDtoInFormTypeEnum.ReceiptOrder;
  }
};
